import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        additionalTableConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új eszköz',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: true,
                formType: '',
            },
            {
                name: "companySiteId",
                label: "Ellátóhely",
                visibility: false,
                formType: "select",
                formSize: 3,
                formVisible: true,
                formRequired: true,
                selectOptions: {
                    apiCallback: Api.getAllCompanySite,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "roomId",
                label: "Szoba",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.findBySiteId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "deviceName",
                label: "Eszköznév",
                visibility: true,
                formType: '',
            },
            {
                name: "deviceId",
                label: "Eszköz azonosító",
                visibility: true,
                formType: 'text',
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "deviceId",
                label: "Eszköz típus azonosító",
                visibility: true,
                formType: 'text',
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "deviceTypeId",
                label: "Eszköz típus azonosító",
                visibility: true,
                formType: 'text',
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            // {
            //     name: "deviceTypeId",
            //     label: "Eszköz típus",
            //     visibility: true,
            //     formType: 'text',
            //     formSize: 6,
            //     formVisible: true,
            //     formRequired: true
            // },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
                formType: 'text',
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
                formType: 'date',
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formType: 'text',
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formType: 'date',
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
                formType: 'number',
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        searchFields: [
            {
                name: "roomId",
                label: "Azonosító",
                formVisible: true,
                formType: '',
            },
            {
                name: "room",
                label: "Szoba",
                formVisible: true,
                formType: 'text',
                formSize: 3,
            },
            {
                name: "deviceName",
                label: "Eszköznév",
                formVisible: true,
                formType: 'text',
                formSize: 3,
            },
            {
                name: "deviceId",
                label: "Eszköz azonosító",
                formVisible: true,
                formType: 'text',
                formSize: 3,
                formRequired: true
            },
            {
                name: "deviceId",
                label: "Eszköz típus",
                formVisible: true,
                formType: 'text',
                formSize: 6,
            },
            {
                name: "deviceTypeId",
                label: "Eszköz típus azonosító",
                formVisible: true,
                formType: 'text',
                formSize: 6,
                formRequired: true
            },
            // {
            //     name: "deviceTypeId",
            //     label: "Eszköz típus",
            //     visibility: true,
            //     formType: 'text',
            //     formSize: 6,
            //     formVisible: true,
            //     formRequired: true
            // },
        ]
    }
}
